import { Tag } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { splitBannerTags } from '@/hooks/hashtagAttributionScope'
import { strings } from '@/strings'

/**
 * Attribution banner shown above a Following-timeline post that surfaced via a
 * hashtag the viewer follows but whose delivering account they do not follow.
 *
 * Each tag is its own link — mirrors the `fromFeedName` nested-interactive
 * idiom with `stopPropagation()` so tapping a tag never triggers the enclosing
 * PostCard's own navigation.
 */
export function HashtagAttributionBanner({ tags }: { tags: string[] }) {
    const navigate = useNavigate()
    const { shown, extra } = splitBannerTags(tags)

    return (
        <div className="pb-1 flex items-center gap-1.5 text-text-secondary-light dark:text-text-secondary-dark text-xs pl-[42px]">
            <Tag className="w-3.5 h-3.5 flex-shrink-0" />
            <span>
                {shown.map((tag, index) => (
                    <span key={tag}>
                        {index > 0 ? ', ' : ''}
                        <button
                            onClick={e => {
                                e.stopPropagation()
                                void navigate(`/hashtag/${encodeURIComponent(tag)}`)
                            }}
                            aria-label={strings.posts.viewHashtagAriaLabel(tag)}
                            className="hover:underline"
                        >
                            #{tag}
                        </button>
                    </span>
                ))}
                {extra > 0 ? ` ${strings.posts.moreHashtags(extra)}` : ''}
            </span>
        </div>
    )
}
